export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=703c3805c21d9510b5301ceced7d874b036f08b148&name=pushAdClickData!'